"use client";

import { useState } from "react";
import Image, { ImageProps } from "next/image";


const requiredProps = ["fill", "layout", "objectFit, width, height"];


interface FallbackImageProps extends Omit<ImageProps, "src"> {
  src: string | null;
  fallbackSrc?: string;
  className?: string;
  width?: number;
  height?: number;
  priority?: boolean;
}

export const FallbackImage = ({
  src,
  fallbackSrc = "/images/img_no_found.jpg",
  className = "w-full h-full object-cover",
  width,
  height,
  priority = false,
  ...props
}: FallbackImageProps) => {

  const somePropsExist = requiredProps.some((prop) => prop in props);

  if (!somePropsExist && !width && !height) {
    width = 300;
    height = 300;
  }

  const [imgSrc, setImgSrc] = useState(src || fallbackSrc);
  return (
    <Image
      {...props}
      src={imgSrc}
      className={className}
      width={width}
      height={height}
      onError={() => setImgSrc(fallbackSrc)}
      alt={props.alt || "Imagen no encontrada"}
      loading={priority ? "eager" : "lazy"}
      priority={priority}
      sizes={props.sizes || "(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, (max-width: 1200px) 25vw, 400px"}
      quality={props.quality || 80}
    />
  );
};
